module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "innerfooter"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "nomobile"
  }, [_vm._v("© Paul Gowder")]), _vm._v(" "), _c('span', {
    staticClass: "nomobile"
  }, [_vm._v("Last rev. " + _vm._s(_vm.lastRev))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "homelink"
  }, [_c('img', {
    staticClass: "footericon",
    attrs: {
      "src": require("../assets/icons/home.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "homelinktext"
  }, [_vm._v("Home")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f42927a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 200
// module chunks = 0